import type { SelectionRow } from './selection';

export const membershipPageSize = 50;
export const membershipOffsetLimit = 10000;

export function validPriority(value: string) {
  return /^\d+$/.test(value) && Number(value) <= 2147483647;
}

export function validPriorityReason(value: string) {
  const reason = value.trim();
  return (
    reason.length > 0 &&
    reason.length <= 512 &&
    Array.from(reason).every((character) => character.charCodeAt(0) >= 32 && character.charCodeAt(0) !== 127)
  );
}

/** Preview only the loaded memberships; never imply an unobserved global position. */
export function priorityPreview(rows: SelectionRow[], selected: SelectionRow | null, value: string) {
  const preview = rows.map((row) => {
    if (
      selected &&
      validPriority(value) &&
      row.hotel_id === selected.hotel_id &&
      row.geo_place_id === selected.geo_place_id
    ) {
      return { ...row, rank: Number(value) };
    }
    return row;
  });
  return preview.sort(
    (a, b) =>
      (a.rank ?? 0) - (b.rank ?? 0) ||
      ((a.hotel_id ?? '') < (b.hotel_id ?? '') ? -1 : (a.hotel_id ?? '') > (b.hotel_id ?? '') ? 1 : 0),
  );
}
